var render, staticRenderFns
import script from "./vPage.vue?vue&type=script&lang=js"
export * from "./vPage.vue?vue&type=script&lang=js"
import style0 from "./vPage.vue?vue&type=style&index=0&id=6672753c&prod&lang=scss&scoped=true"
import style1 from "./vPage.vue?vue&type=style&index=1&id=6672753c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672753c",
  null
  
)

export default component.exports